import React, { useEffect, useState } from 'react';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import BOM from "@system/config/bom";
import Helper from 'src/helper/Helper';
import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import Constants from 'src/helper/Constants';
const GuestBomList = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { bom_listing } = props;
    const [listOfBOM, setListOfBOM] = useState({});
    const { LifeCycleRisk: { LOW, MED } } = Constants

    useEffect(() => {
        setListOfBOM(bom_listing);
    }, [bom_listing]);

    function bomOpen(){
        localStorage.setItem("adobeEventType","bomOpened");
    }


    return (
        <>
            {!(listOfBOM !== undefined && Object.keys(listOfBOM).length > 0) && __check(['BOM_PROJECT_API_CALL']).render}
            {Object.keys(listOfBOM).length ?
                <div className='accordion m-t-30 mb-2 position-relative'>
                    <div>
                        {__check(['BOM_PROJECT_API_CALL'], { overlay: true }).render}
                    </div>
                    <div className='accordion-item '>
                        <h2 className="accordion-header font-24 m-t-10 text-black font-apecru px-3 mb-3">
                            Active BOM
                        </h2>

                        <div>
                            <table className="table font-12 bg-grey2">
                                {Object.keys(listOfBOM).map((v, i) => (
                                    <>
                                        <tr id={i}>
                                            <td>
                                                <a
                                                    href={BOM.getBomDetailByIdRouteURL(listOfBOM[v].bomId, {
                                                        lifeCycle: listOfBOM[v].bomHealthRisk
                                                    })}
                                                    className="text-blue2 mb-1 d-block font-bold" onClick={bomOpen}>{listOfBOM[v].bomName}</a>
                                                <p>Last updated: {Helper.dateFormatFromString(listOfBOM[v].updatedDate, true)}</p>
                                            </td>
                                            <td>
                                                {listOfBOM[v].exactMatchCount + '/' + listOfBOM[v].totalCount + ' exact matches'}
                                            </td>
                                            {listOfBOM[v].bomHealthRisk &&
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <img src={listOfBOM[v].bomHealthRisk == LOW ? lifecyclegreen : listOfBOM[v].bomHealthRisk == MED ? lifecycleyellow : lifecyclered} className="lifecycle-icon-green me-1" />
                                                        {listOfBOM[v].bomHealthRisk}&nbsp;Health
                                                    </div>
                                                </td>
                                            }
                                            <td>
                                                <div className="text-nowrap"><i className="fa fa-download font-16 me-1" /><a className='disabled-link'> Download</a></div>
                                               
                                            </td>
                                        </tr>
                                    </>

                                ))}
                            </table>
                        </div>
                    </div>
                </div>
                : ""
            }
        </>
    );
}

export default GuestBomList;